module.exports = __webpack_public_path__ + "assets/media/vk-footer.8cfaecce.svg";